import { css } from 'styled-system/css';
import { Box, Flex } from 'styled-system/jsx';
import CloseIcon from '@/common/assets/icons/closeIcon.svg?react';
import RedCloseIcon from '@/common/assets/icons/redCloseIcon.svg?react';
import { token } from 'styled-system/tokens';
import Typography from '@/common/components/base/typography/Typography';
import Button from '@/common/components/base/button/Button';

const CameraDenyModal = ({
  confirm,
  cancel,
}: {
  confirm: () => void;
  cancel: () => void;
}) => {
  return (
    <Box
      className={css({
        background: 'black-5',
        position: 'fixed',
        top: '0',
        left: '0',
        width: '100vw',
        height: '100vh',
      })}
    >
      <Flex
        className={css({
          backgroundColor: 'white',
          position: 'absolute',
          width: '250px',
          height: '400px',
          borderRadius: '10px',
          p: '1rem',
          top: '15%',
          right: '20%',
        })}
      >
        <Box>
          <CloseIcon stroke={token('colors.black-3')} />
        </Box>
        <Flex alignItems="center">
          <RedCloseIcon />
          <Flex
            flexDirection="column"
            textAlign="center"
            rotate="90deg"
            marginRight={-80}
          >
            <Typography textStyle="b1" h="40px" textWrap="nowrap">
              آیا برای لغو فرآیند عکس‌برداری اطمینان دارید؟
            </Typography>
            <Typography textStyle="b2" h="40px" textWrap="nowrap">
              در صورت لغو فرآیند لازم است کلیه مراحل را از ابتدا انجام دهید
            </Typography>
            <Flex gap="1rem">
              <Button
                onClick={cancel}
                variant="outlined"
                color="common"
                minW="150px"
              >
                بازگشت
              </Button>
              <Button
                onClick={confirm}
                variant="contained"
                color="danger"
                minW="150px"
              >
                لغو فرایند
              </Button>
            </Flex>
          </Flex>
        </Flex>
      </Flex>
    </Box>
  );
};

export default CameraDenyModal;
